import { useTranslation } from 'react-i18next';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import { TableCell, TableHead } from 'common/components/Table';
import { IBudgetRequestListItemFragment } from 'graphql/types';

import { UserBudgetRequestsTableRow } from './UserBudgetRequestsTableRow';

interface IProps {
    budgetRequests: IBudgetRequestListItemFragment[];
}

export const UserBudgetRequestsTable = ({ budgetRequests }: IProps) => {
    const [translate] = useTranslation();

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: '30%' }}>
                            {translate(
                                'userBudgetRequestsTable.columns.request'
                            )}
                        </TableCell>
                        <TableCell>
                            {translate('userBudgetRequestsTable.columns.group')}
                        </TableCell>
                        <TableCell>
                            {translate(
                                'userBudgetRequestsTable.columns.amount'
                            )}
                        </TableCell>
                        <TableCell>
                            {translate('userBudgetRequestsTable.columns.date')}
                        </TableCell>
                        <TableCell>
                            {translate(
                                'userBudgetRequestsTable.columns.status'
                            )}
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {budgetRequests.map((budgetRequest) => (
                        <UserBudgetRequestsTableRow
                            budgetRequest={budgetRequest}
                            key={budgetRequest.id}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
